const locale = {
  message: 'Are you sure you want to delete?',
  confirm: 'Confirm',
  delete: 'Delete',
  cancel: 'Cancel',
  more: 'More'
};

export default locale;
